import React, { useEffect } from "react";

import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import useModal from "@hooks/useModal";

import DeletedPressModal from "../DeletedPressModal/DeletedPressModal";

type Props = {
  children: React.ReactNode;
  type?: "press" | "publication" | "ctg";
};

const DeletedPressBoundary = ({ children, type }: Props) => {
  const { data: articleInfo } = useArticleInfoQuery();
  const { closeModal, openModal, isModal } = useModal();
  const deletedArticle = articleInfo?.deleted || false;

  useEffect(() => {
    if (deletedArticle) {
      openModal();
    }
  }, [deletedArticle, openModal]);
  return (
    <>
      {children}
      {isModal && <DeletedPressModal closeModal={closeModal} type={type} />}
    </>
  );
};

export default DeletedPressBoundary;
